<template>
    <b-card title="Filters" class="text-center" title-tag="h5">
        <b-card-body>
            <b-row class="mt-12">
                <b-col md="6" cols="12">
                    <b-form-group
                        id="fieldset-orderType"
                        label="Order Type"
                        label-for="input-orderType"
                        label-cols="3"
                    >
                        <b-form-select
                            id="input-orderType"
                            v-model="model.type"
                            value-field="id"
                            text-field="name"
                            :options="orderTypes"
                        >
                            <template #first>
                                <b-form-select-option :value="null"
                                    >-- Any Type --</b-form-select-option
                                >
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>

                <b-col md="6" cols="12">
                    <b-form-group
                        id="fieldset-officer"
                        label="Officer"
                        label-for="input-officer"
                        label-cols="3"
                    >
                        <b-form-select
                            id="input-officer"
                            v-model="model.driver_id"
                            value-field="id"
                            text-field="first_name"
                            :options="officers"
                        >
                            <template #first>
                                <b-form-select-option :value="null"
                                    >-- Any Officer --</b-form-select-option
                                >
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>

                <b-col md="6" cols="12">
                    <b-form-group
                        id="fieldset-created_start"
                        label="Start Date"
                        label-for="input-created_start"
                        label-cols="3"
                    >
                        <b-form-input
                            type="date"
                            id="input-created_start"
                            v-model="model.created_start"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col md="6" cols="12">
                    <b-form-group
                        id="fieldset-created_end"
                        label="End Date"
                        label-for="input-created_end"
                        label-cols="3"
                    >
                        <b-form-input
                            type="date"
                            id="input-created_end"
                            v-model="model.created_end"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col md="6" cols="12">
                    <b-form-group
                        label="Completed"
                        label-cols="3"
                        v-slot="{ ariaDescribedby }"
                    >
                        <b-form-radio-group
                            id="radio-group-completed"
                            v-model="model.completed"
                            :options="completedValues"
                            :aria-describedby="ariaDescribedby"
                            name="radio-completed"
                        >
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
                <b-col md="6" cols="12">
                    <b-form-group
                        label="Updates"
                        label-cols="3"
                        v-slot="{ ariaDescribedby }"
                    >
                        <b-form-radio-group
                            id="radio-group-updated"
                            v-model="model.is_updated"
                            :options="changedValues"
                            :aria-describedby="ariaDescribedby"
                            name="radio-updated"
                        >
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-card sub-title="Review">
                        <b-row>
                            <b-col md="6" cols="12">
                                <b-form-select
                                    id="input-checkoff"
                                    v-model="model.checkoff_type_id"
                                    value-field="id"
                                    text-field="name"
                                    :options="checkoffTypes"
                                >
                                    <template #first>
                                        <b-form-select-option :value="null"
                                            >-- Any Review
                                            --</b-form-select-option
                                        >
                                    </template>
                                </b-form-select>
                            </b-col>
                            <b-col md="6" cols="12">
                                <b-form-radio-group
                                    :disabled="!model.checkoff_type_id"
                                    id="radio-group-checkoff_completed"
                                    v-model="model.checkoff_completed"
                                    :options="completedValues"
                                    name="radio-checkoff_completed"
                                >
                                </b-form-radio-group>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>
import moment from 'moment'
import permissionsMixins from '@/mixins/permissionsMixins'

const dateRangeEnum = {
    today: 0,
    yesterday: 1,
    custom: 2,
}

const defaultModel = Object.freeze({
    driver_id: null,
    checkoff_type_id: null,
    completed: null,
    checkoff_completed: null,
    type: null,
    is_updated: null,
    created_start: moment().startOf('month').format('YYYY-MM-DD'),
    created_end: moment().endOf('month').format('YYYY-MM-DD'),
})

export default {
    name: 'orders-queryfilters',
    mixins: [permissionsMixins],
    data() {
        return {
            model: { ...defaultModel },
        }
    },
    props: ['dateRange', 'orderTypes', 'checkoffTypes', 'officers', 'value'],
    computed: {
        completedValues() {
            return [
                { value: null, text: 'Any' },
                { value: 1, text: 'Yes' },
                { value: 2, text: 'No' },
            ]
        },
        changedValues() {
            return [
                { value: null, text: 'All' },
                { value: 1, text: 'Changed' },
                { value: 2, text: 'Unchanged' },
            ]
        },
    },
    mounted() {
        // this.$store.dispatch('orders/fetchDrivers')
        //init remote filters
    },

    watch: {
        value: {
            handler: function (val) {
                console.log('I am here')
                this.changeFilters(val)
            },
            deep: true,
        },
        model: {
            handler: function (x) {
                if (!x.checkoff_type_id) {
                    this.model.checkoff_completed = null
                }
                this.updateModel()
            },
            deep: true,
        },

        dateRange: function (val) {
            switch (val) {
                case dateRangeEnum.today:
                    this.model.created_start = moment().format('YYYY-MM-DD')
                    this.model.created_end = moment().format('YYYY-MM-DD')
                    break
                //created_end: moment().endOf('month').format('YYYY-MM-DD'),
                case dateRangeEnum.yesterday:
                    this.model.created_start = moment()
                        .subtract(1, 'days')
                        .format('YYYY-MM-DD')
                    this.model.created_end = moment()
                        .subtract(1, 'days')
                        .format('YYYY-MM-DD')
                    break
                default:
                    break
            }
        },
    },
    methods: {
        updateModel() {
            const { value, model } = this
            this.$nextTick(() => {
                this.$emit('input', { ...value, ...model })
            })
        },
        changeFilters(value) {
            console.log('filters before', value)
            for (const key in defaultModel) {
                this.$set(this.model, key, value[key] || defaultModel[key])
            }
            console.log('filters after', this.model)
        },
    },
}
</script>
